<template>
  <div class="pageBreakBefore">
    <div class="subreport-header">
      Uncertified Participants
    </div>
    <div class="row">
      <div class="col-2 text-left text-danger">
        Participant
      </div>
      <div class="col-2 text-center text-danger">
        Patrol
      </div>
      <div class="col-8 text-left text-danger">
        Comments
      </div>
    </div>
    <div
      class="row pt-2 pb-2 border-bottom"
      v-for="t in tickets"
      :key="t.FullName"
    >
      <div class="col-2 text-left">
        {{ t.FullName }}
      </div>
      <div class="col-2 text-center">
        {{ t.Critter }}
      </div>
      <div class="col-8 text-left">
        {{ t.TicketCompletionComments }}
      </div>
    </div>
  </div>
</template>

<script>
import ticketApi from '@/services/api/ticket.js'

export default {
  name: 'ReportCloseoutUncertifiedParticipants',
  data: function () {
    return {
      tickets: [],
      cellStyle: {
        padding: '0',
        'font-size': '10px',
        'text-align': 'center',
        'vertical-align': 'baseline'
      },
      headerCellStyle: {
        padding: '0 0 0 0 !important',
        margin: '0',
        height: '20px',
        'font-size': '10px',
        'vertical-align': 'baseline',
        'text-align': 'center',
        'overflow-wrap': 'break-word'
      }
    }
  },
  mounted: function () {
    ticketApi
      .getIncompleteTickets(this.$root.courseKey)
      .then(x => {
        this.tickets = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>
